// extracted by mini-css-extract-plugin
export var continueShoppingLink = "basketList-module--continue-shopping-link--ZBdWm";
export var emptyBasketWrapper = "basketList-module--empty-basket-wrapper--NSt4u";
export var shippingListItem = "basketList-module--shipping-list-item--YzhOT";
export var totalContainer = "basketList-module--total-container--VfigS";